import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { DtcFileRequestsTable } from '../../../../../../../../../../../features/dtc/files/v1/dtc-file-requests-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file-request/_file-request/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorDtcc,
      label: 'DTC File Requests',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorDtcc>,
  head: () => getPageHead('DTC File Requests'),
  component: DtcFileRequestsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorDtcc}
    />
  );
}

function DtcFileRequestsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DtcFileRequestsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
